import styled from "styled-components";

const BreadcrumbWrapper = styled.div`
    width: 100vw;
    padding: 1rem 1.4rem;
    display: flex;
    @media (max-width: 990px) {
        padding-top: 80px;
    }
`;

export {
	BreadcrumbWrapper,
};
